import { IErrorsInput, ValidatorHelper } from "../helpers/ValidatorHelper";
import { LookupDataService } from "../services/LookupDataService";
import { CountryService } from "../services/CountryService";
import { StaffService } from "../services/StaffService";
import { DeclarationService } from "../services/DeclarationService";
import { DeclarationCostService } from "../services/DeclarationCostService";

export default class DeclarationCostActions {
  async InitAsync(Record: any) {

    let responsesDeclaration = await new DeclarationService().Edit(Record);
    let responsesCurrencies = await new LookupDataService().GetAllByTypeID(Record);
    let responsesBudgets = await new DeclarationService().GetBudgetsPerDeclaration(Record);
    let responses = [responsesCurrencies, responsesBudgets, responsesDeclaration];

    //napravi validacija
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }

  
  
  async SaveAsync(Record: any) {
    let jsonInputData: IErrorsInput[] = [
      {
        element: "dfName",
        type: "required",
        value: Record.dfName,
        message: "Name is required",
      },
      {
        element: "dfBudgetName",
        type: "SelectEmpty",
        value: Record.dfBudgetName,
        message: "Budget is required",
      }
    ];


    //validacija
    let validationMessages = new ValidatorHelper().validateClient(jsonInputData);
    if (validationMessages.length > 0) {
      let response = {
        error: true, //oznaci deka ima greska
        error_description: "Unable to save",
        ValidationMessages: validationMessages, //vrati gi greskite za GUI
      };
      return response;
    }


    //napravi validacija
    let response = await new DeclarationCostService().SaveCost(Record);
    let responses = [response];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }

  
  async DeleteAsync(Record: any) {
    //napravi validacija
    let response = await new DeclarationCostService().DeleteCost(Record);
    let responses = [response];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }

  async GetByDeclarationIDAsync(Record: any) {
    //napravi validacija
    let response = await new DeclarationCostService().GetByDeclarationID(Record);
    let responses = [response];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }

  
  async GetEurRateAsync(Record: any) {
    //napravi validacija
    let response = await new DeclarationCostService().GetEurRate(Record);
    let responses = [response];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }

  
  async UploadAsync(Record: any) {
    //napravi validacija
    let response = await new DeclarationCostService().UploadCost(Record);
    let responses = [response];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }

  
  async DownloadCostUrlAsync(Record: any) {
    //napravi validacija
    let response = await new DeclarationCostService().DownloadCostUrl(Record);
    return response;
  }

  async DownloadCostAsync(Record: any) {
    //napravi validacija
    let response = await new DeclarationCostService().DownloadCost(Record);
    return response;
  }
  
}
